import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';

import { CalendarService } from '../calendar-service.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-calendar-event',
  templateUrl: './calendar-event.component.html',
  styleUrls: ['./calendar-event.component.scss']
})
export class CalendarEventComponent implements OnInit {

  //eventForm: FormGroup;

  eventForm = this.formBuilder.group({
    consultantName: ['', Validators.required],
    appointmentDate: ['', Validators.required]
  });

  @Input() event = {
    caseRef: '',
    client: '',
    clientPostcode: '',
    appointmentDate: null,
    consultantName: '',
    distanceToClient: 0,
    appointmentCreatedDate: null,
    appointmentCreatedUser: '',
    caseId: -1
  }

  constructor(
    private formBuilder: UntypedFormBuilder, 
    private calendarService: CalendarService, 
    public activeModal: NgbActiveModal) {

    this.calendarService.getEvent(this.event.caseId).subscribe(x => {
      this.event = x[0];
    });
  }

  ngOnInit() {
  }

  onNoClick(): void {
    this.activeModal.close();
  }

}
